import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "./AddHelpline.css";
import "react-toastify/dist/ReactToastify.css";

class AddHelpline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        sprtNo: "",
        sprtEmail: "",
        role: "Select Role",
        isActive: true
      }
    };
  }
  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };
  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name == "sprtNo") {
      this.setState({
        value: { ...this.state.value, sprtNo: value }
      });
    } else if (name == "sprtEmail") {
      this.setState({
        value: { ...this.state.value, sprtEmail: value }
      });
    }
    else if (name == "isActive") {
      this.setState({
        value: { ...this.state.value, isActive: value }
      });
    }
  };

  onChangeOption = event => {
    this.setState({ value: { ...this.state.value, role: event.target.value } });
  };
  submit = () => {
    let data = this.state.value;
    let regexemail = /^\S+@\S+\.\S+$/;
    let regexcode = /^[7-9][0-9]{9}$/;
    if (
      data.sprtNo === "" ||
      data.sprtEmail === "" ||
      data.role === "Select Role"
    ) {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else if (!regexemail.test(data.sprtEmail)) {
      toast.error("Enter a valid email", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }  else if (!regexcode.test(data.sprtNo)) {
      toast.error("Enter a valid mobile number", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      this.props.AddHelpline(data);
      this.setState({
        value: {
          sprtNo: "",
          SprtEmail: "",
          role: "Select Role",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        sprtNo: "",
        SprtEmail: "",
        role: "Select Role",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showAddModel}
          onHide={this.closeModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Helpline</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>

              <Form>
                <Row>
                  <Col lg={6} sm={12} xs={12}>

                    <Form.Group controlId="sprtNo">
                      <Form.Label> Support Number </Form.Label>
                      <Form.Control
                        type="text"
                        // placeholder="Name"
                        autoComplete="off"
                        name="sprtNo"
                        onChange={this.onChange}
                      // value={this.state.value.helplineName}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="sprtEmail">
                      <Form.Label> Support Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="sprtEmail"
                        autoComplete="off"
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>
                </Row>
                <Row>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="role">
                      <Form.Label> Role</Form.Label>
                      <div style={{ width: "100%" }}>
                        <select style={{ width: "100%" }}
                          onChange={this.onChangeOption}
                          className="helplineSelect"
                          id="type"
                          value={this.state.value.role}
                        >
                          <option value="select" defaultValue>
                            Select Role
                      </option>
                          <option value="Chemist">Chemist</option>
                          <option value="Patient">Patient</option>
                          <option value="Distributor">Distributor</option>
                          <option value="Licensee">Licensee</option>
                        </select>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <label style={{ display: "flex", marginTop: "0px" }}>
                      <Form.Group controlId="sprtEmail">
                        <Form.Label> Active</Form.Label>
                        <div style={{ marginTop: "0px", marginLeft: "10px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={this.state.value.isActive}
                          />
                        </div>
                      </Form.Group>
                    </label>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddHelpline;
